module.exports = __webpack_public_path__ + "static/img/product04_01.944d5e8.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/product04/product04_01.png
// module id = Rb/s
// module chunks = 1